import React, { useMemo, useState } from "react";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { useSelector } from "react-redux";

import { userSelector } from "../../../modules/App/state/selectors";

import useTenants from "./hooks/useTenants";

import styles from "./styles.module.scss";

const TenantSwitcher = () => {
    const user = useSelector(userSelector);
    const [ anchorEl, setAnchorEl ] = useState(null);

    const { tenants, currentTenantCode, handleSwitch } = useTenants(user);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const tenantName = useMemo(
        () => {
            if(user && user.user_to_tenants) {
                const { tenant_code, user_to_tenants } = user;

                return user_to_tenants.find(({ tenant: { code } }) => code === tenant_code)?.tenant?.name;
            }

            return "";
        },
        [ user ]
    );

    return (
        <div className={styles.tenant}>
            <div className={styles.tenantInfo}>
                {tenantName}
            </div>

            {
                tenants.length > 1 && (
                    <>
                        <IconButton
                            onClick={handleClick}
                            disabled={tenants.length === 0}
                        >
                            <AutorenewIcon/>
                        </IconButton>

                        <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {
                                tenants.map(({ tenant }, item) => {
                                    if(tenant.code === currentTenantCode) {
                                        return null;
                                    }

                                    return (
                                        <MenuItem
                                            key={item}
                                            onClick={() => handleSwitch(tenant.code)}
                                        >
                                            {tenant.name}
                                        </MenuItem>
                                    );
                                })
                            }
                        </Menu>
                    </>
                )
            }
        </div>
    );
};

export default TenantSwitcher;
